<script setup lang="ts">
/**
 * Application root.
 *
 * The current route's view and the design system toaster, mounted exactly once
 * so any module can raise a notification without mounting its own. And the
 * theme, started here so it applies on every screen, the login included.
 */
import { ArSonner } from '@beonit/adaptive-raindrop';
import { useThemeStore } from '@shared/presentation/theme/store.js';

useThemeStore();
</script>

<template>
  <RouterView />
  <ArSonner position="bottom-right" rich-colors />
</template>
